module.exports = __webpack_public_path__ + "content/dam/oppo/coloros/img/img (70).ef3e3acf.jpg";